import React, { Component, createRef } from 'react';
import { type Theme } from '@mui/material';
//import Grid from '@mui/material/Grid';
import { Box, Button, Grid } from '@mui/material';
import { Accordion, AccordionActions, AccordionDetails } from '@mui/material';
import { Dialog, DialogContent, DialogTitle, Divider } from '@mui/material';

import { tuples, ucfirst, clone } from '../../core/utils';
import { formatDate, formatStatus, formatState, formatSource } from '../../components/renderers';

import { setConfig } from '../../core';
import {getConfig} from '../config';
import RegistrationWizard from '../custom/momoregister';
import {CustomBase} from '../customs';

//import { type } from 'node:os';
//import { title } from 'node:process';
import { ClosableBar, LoadDialog, ProgressDialog } from '../../components/dialogs';
import form from '../../components/form';
import { CSVIcon, ZIPIcon } from '../../components/icons';
import { ServiceWindow } from '../../components/service';


const s:any ={
  root: {
    width: '100%',
  },
  titlebar: {
    padding:0,
    backgroundColor: 'success.light',
  },
  details: {
    alignItems: 'center',
    p: 1,

  },
};



class Subscription extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;

  form = createRef();
  constructor(props:any) {
    super(props);
    this.state = {
      conf: {},
      views:[],
      count:0,
      record: {},
      data: [],
      wizmode: 'add',
      action: 'Create', 
      actions: [],
      open: true,
      valid: false,
      loading: false,
      loadcolor: 'inherit',
      params:{s:props.service,a:'upload'},
      datasets: null,
      dataset: null
    };
  }

  configuration = () => {
    const cbip = {InputLabelProps:{ shrink:true,}};
    const config = {
      service:{
        name:'customer',
        title:'Subscription',
        fields:['rid','fnm','mnm','lnm','nam','gdi','mbn','dcd','aci','acn','acc','bci','coi','coy','cos',
                'ano','anm','cui','cuy','cus','bri','bnm','bcd','iti','itn','itc','idn','idy','tel','knm',
                'krn','kcn','rmk','sts','ast','stp'],
        grid: [['dcd','Date'],['nam','Name'],['gdi','Gender'],['acn','Account'],['bnm','Branch'],['bci','Reference'],['mbn','Mobile'],['idy','ID'],
              ['coy','Country'],['sts','Status'],['stp','Stamp']],
        menu: {mnu:[{t:'Customer',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
        eform:[
          {id:'fnm',label:'Firstname',type:'tf',req:1,col:1,ops:{}},
          {id:'mnm',label:'Middlename',type:'tf',req:0,col:1,ops:{}},
          {id:'lnm',label:'Lastname',type:'ta',req:0,col:1,ops:{}},
          {id:'gdi',label:'Gender',type:'fa',req:0,col:1,ops:{},cp:{t:'lcs',s:'gender'}},
          {id:'mbn',label:'Mobile',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'aci',label:'Service',type:'fa',req:1,col:1,ops:{},cp:{t:'bcs',s:'idtype'}},
          {id:'bci',label:'ServiceID',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'coi',label:'Country',type:'fa',req:1,col:1,ops:{},cp:{t:'bcs',s:'idtype'}},
          {id:'iti',label:'ID Type',type:'fa',req:1,col:1,ops:{},cp:{t:'bcs',s:'idtype'}},
          {id:'idn',label:'ID No',type:'tf',req:0,col:1,ops:{} },
          {id:'cui',label:'Currency',type:'fa',req:1,col:1,ops:{},cp:{t:'bcs',s:'idtype'}},
          {id:'bri',label:'Branch',type:'fa',req:1,col:1,ops:{},cp:{t:'bcs',s:'idtype'}},
          {id:'ano',label:'Account No',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'anm',label:'Account Name',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'ctn',label:'Contact',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'knm',label:'Kin Name',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'kre',label:'Kin Relation',type:'tf',req:0,col:1,ops:{}},
          {id:'kco',label:'Kin Contact',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'rmk',label:'Remarks',type:'ta',req:0,col:1,ops:{}},
          {id:'sts',label:'Status',type:'fa',req:0,col:1,ops:{},cp:{t:'lcs',s:'status'}},
        ],
      },
      fw:false,
      create:true,
      actions: {add:'Add'},
      panels: {add:'wizard'}
    };
    return config;
  }

  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }

  onExpChange = (event:any,expanded:boolean) => {
    if (!expanded) this.setState({open:false})
  }

  onClose = (event:any) => {
    const {setHome} = this.props;
    this.setState({open:false})
    if(typeof setHome === 'function'){
      setHome();
    }
  }

  onResponse = (status: any, response: any) => {
    if (status) {
      this.onClose(response);
    }
  };

  render0() {
    //const { classes, theme, configuration, children, ...others } = this.props;
    const { title='Subscription'}  = this.props;

    const {open,valid,loading,loadcolor} = this.state;
    //const offmode = !valid||loading;

    //const conf = configuration||this.formconfig;
    //const customconfig = Object.assign({}, conf()||{});
    //console.log('extraconfig',service,extraconfig);
    //const config = setConfig(customconfig); //

    return (
      <Box sx={{...s.root}}>
        <Grid container spacing={{xs:1,sm:3}}>
          <Grid size={{xs:12,sm:6}}>
            
            <Dialog open={open}>
              <DialogTitle id="window-dialog-title" sx={{...s.titlebar}} >
                <ClosableBar onClose={this.onClose}>{title}</ClosableBar>
              </DialogTitle>
              <DialogContent sx={{...s.dialogcontent}}>
                <Box sx={{...s.root}}>
                  
                  <Accordion defaultExpanded onChange={this.onExpChange}>
                    <AccordionDetails sx={{...s.details}}>
                      <Box sx={{...s.root}}>
                      <LoadDialog open={loading} onClick={this.onClose} value={"wait!"} color={loadcolor} />
                        <RegistrationWizard />
                      </Box>
                    </AccordionDetails>
                    <Divider />
                  </Accordion>
                </Box>
              </DialogContent>
            </Dialog>
          </Grid>
        </Grid>
      </Box>
    );
  }

  render = () => {
    //console.log('in render');
    const {
      code,
      title,
      service,
      configuration,
      actionSet,
      //rowActions,
      onSubmit,
      showNotification,
      classes,
      ...others
    } = this.props;
    const { formformatters, onChange } = this.props;
    const {
      url,
      action,
      loading,
      wizmode,
      open,
      record,
      data,
      //recordCount,
      //pageMode: pmode,
      // page,
      // rowsPerPage,
      // order,
      // orderBy,
    } = this.state;

    //const { search, query, startSearch, stopSearch } = this.props;

    // if (search === true) {
    //   this.onSearch(service, query);
    //   if (typeof stopSearch === 'function') stopSearch();
    // }
    // //console.log(url,action,loading,wizmode,fwopen,record,data,recordCount,page,rowsPerPage,order,orderBy);
    // //console.log('render title,service',this.props.service);
    // //const title = ucfirst(this.props.title||service);

    // //const fnConfig = configuration || this.configuration;
    // //const config = fnConfig();//console.log('configuration:',config);

    // //console.log('configuration',service,configuration());
    // const extraconfig = Object.assign(
    //   {},
    //   this.configuration(),
    //   configuration()
    // );
    // //console.log('extraconfig',service,extraconfig);
    // const config = setConfig(extraconfig); //
    // //console.log('config',service,config);

    const conf = configuration||this.configuration;
    const customconfig = Object.assign({}, conf()||{});
    const config = setConfig(customconfig); 

    const ServiceConfig = clone(config);
    //console.log('ServiceConfig',service,ServiceConfig);
    const SData = ServiceConfig.service; //ServiceData['service'];
    if (!SData) this.props.setHome();
    const stitle = ucfirst(SData.title || service);
    // = 'local' } = SData;
    //console.log(`pageMode:${pageMode},pmode:${pmode}`);
    //const cancreate = this.isAddEnabled(rowActions, ServiceConfig.create);
    const panels = ServiceConfig.panels;

    const Columns = tuples(SData.grid);
    if (Columns.length > 0) Columns.push({ k: 'ACTION', v: '' });
    //console.log('tuples',Columns,Columns.length);
    const cm = SData.cols;
    const fmformatters = {
      ste: formatState('form'),
      sts: formatStatus,
      dcd: formatDate,
      stp: formatDate,
      src: formatSource,
    };
    // const gdformatters = {
    //   sts: this.formatStatus('grid'),
    //   dcd: formatDate,
    //   stp: formatDate,
    //   src: formatSource,
    // };
    //add formatters from config and from class to base formatters
    const cformatters = ServiceConfig.formatters || {};
    const { form: cfformatters, grid: cgformatters } = cformatters;
    const _formformatters = Object.assign(
      {},
      fmformatters,
      cfformatters,
      formformatters || {}
    );
    // const _gridformatters = Object.assign(
    //   {},
    //   gdformatters,
    //   cgformatters,
    //   gridformatters || {}
    // );
    // const _rowActions = rowActions || this.rowActions;
    // //const _handleRecord = this.handleRecord;// || this.handleRecord;
    // const newrecord = { item: { sts: 1, a: 'add' }, action: 'add' };
    // // console.log('service.classes',classes);
    // console.log('service.theme',theme);
    const isform = action !== '';
    const fabstyle = { position: 'fixed', right: 20, bottom: 20 };
    //console.log('isform',isform);
    console.log('action',action,wizmode,isform);
    return (
      <Box>
        {isform && open && (
          <ServiceWindow
            open={open}
            mode={wizmode}
            code={code}
            title={`${action} ${stitle}`}
            service={service}
            //service={"subscriber"}
            url={url}
            panels={panels}
            //actions={_rowActions}
            actionSet={actionSet}
            //rowActions={rowActions}
            record={record}
            data={data}
            sdata={SData}
            sconfig={ServiceConfig}
            formatters={_formformatters}
            onChange={onChange}
            //refresh={this.refresh}
            onSubmit={onSubmit}
            onResponse={this.onResponse}
            onClose={this.onClose.bind(this)}
            showNotification={showNotification}
            swidth={"md"}
            {...others}
          />
        )}
        {loading && (
          <ProgressDialog
            open={loading}
            loading={loading}
            startLoading={this.startLoading} //.bind(this)
            stopLoading={this.stopLoading} //.bind(this)
          />
        )}
      </Box>
    );
  };
}

export default Subscription;
